import LangData from '@/lang/all'
import { langMap } from '@/config/';
import InnerLangData from '@/lang/inner';
import ActivityLangData from '@/lang/activity';
import ReviewLangData from '@/lang/review';
import FeedbackLangData from '@/lang/feedback';
import AchievementLangData from '@/lang/achievement';
import GuideLangData from '@/lang/guide';

export function attach(d: any  , a: string, c: Function, b?: boolean) {
  if (d.addEventListener) {
    d.addEventListener(a, c, b)
  } else {
    if (d.attachEvent) {
      d.attachEvent("on" + a, c)
    }

  }
};

export function detach(d: any, a: string, c: Function, b?: boolean) {
  if (d.removeEventListener) {
    d.removeEventListener(a, c, b);
  } else {
    if (d.detachEvent) {
      d.detachEvent("on" + a, c);
    }
  }
}

function _getCookie(b: string){
	var a;
	return filterXSS((a = document.cookie.match(RegExp("(^|;\\s*)" + b + "=([^;]*)(;|$)"))) ? unescape(a[2]) : null);
}

export const getCookie = _getCookie

export function setCookie(name: string, value: string, expires?: any, path?: any, domain?: any, secure?: any){
	var expdate = new Date();
	var expires = arguments[2] || '0';
	var path = arguments[3] || "/";
	var domain = arguments[4] || '';
	var secure = arguments[5] || false;
	if(expires){
		expdate.setMinutes(expdate.getMinutes() + parseInt(expires));
	}
	var cookietemp = escape(name) + '=' + escape(value) + (expires ? '; expires=' + expdate.toUTCString() : '') + '; path=' + path + (domain ? '; domain=' + domain : '') + (secure ? '; secure' : '');
	console.log('cccc:', cookietemp)
  document.cookie = cookietemp;
}

 export function delCookie(name: string){
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = _getCookie(name);
	document.cookie = name + "=" + cval + ";expires=" + exp.toUTCString();
}

function filterXSS(e: any){
	if(!e) return e;
	for(; e != unescape(e);){
		e = unescape(e);
	}
	var r = ["<", ">", "'", '"', "%3c", "%3e", "%27", "%22", "%253c", "%253e", "%2527", "%2522"];
	var n = ["&#x3c;", "&#x3e;", "&#x27;", "&#x22;", "%26%23x3c%3B", "%26%23x3e%3B", "%26%23x27%3B", "%26%23x22%3B", "%2526%2523x3c%253B", "%2526%2523x3e%253B", "%2526%2523x27%253B", "%2526%2523x22%253B"];
	for(var a = 0; a < r.length; a++){
		e = e.replace(new RegExp(r[a], "gi"), n[a]);
	}
	return e;
}


export function getScrollTop(element?: any) {
  if (element) {
    return element.scrollTop;
  }
  let scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0
  if(document.body){
    bodyScrollTop = document.body.scrollTop
  }
  if(document.documentElement){
    documentScrollTop = document.documentElement.scrollTop
  }
  scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
  return scrollTop
}

export function getScrollHeight (element?: any) {
  if (element) {
    return element.scrollHeight;
  }
  let scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0
  if(document.body){
    bodyScrollHeight   = document.body.scrollHeight
  }
  if(document.documentElement){
    documentScrollHeight = document.documentElement.scrollHeight
  }
  scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
  return scrollHeight
}

export function getWindowHeight (element?: any) {
  if (element) {
    return element.clientHeight;
  }
  let windowHeight = 0
  if(document.compatMode == "CSS1Compat"){
    windowHeight = document.documentElement.clientHeight
  } else {
    windowHeight = document.body.clientHeight
  }
  return windowHeight
}

export function getPara(paraName: string, sUrl: string){
	if (typeof(sUrl) == 'undefined'){
		sUrl = document.location.href;
	}
	const urlRegex = new RegExp(paraName+"=[^&#\?]*", "igm");
	const para = sUrl.match( urlRegex );
	if(!para){
		return "";
	}
	const v = para[0];
	let from = v.indexOf( "=" );
	let paraValue = v.substr(from+1, v.length);
	while( paraValue.indexOf('<') >= 0 ){
		paraValue = paraValue.replace('<','');
	}
	if( paraValue .indexOf( "#" ) > 0 ){
		from = paraValue .indexOf( "#" );
		paraValue = paraValue .substr(0, from );
	}
	return paraValue;
}

function getCurrentLanguage () {
  const cookieLang = getCookie('language');
  const urlLang = getPara('lang', location.href);
  const defaultLang = 'en_US';
  if (cookieLang) {
    // meemo client
    console.log('cookieLang:', cookieLang);
    return cookieLang;
  } else if (urlLang) {
    // pubg client
    let langInner =langMap.find((item) => item.code == urlLang);
    console.log('langInner:', langInner);
    // 兼容一下code: HK TW
    if (!langInner) {
      langInner =langMap.find((item) => item.code == urlLang.toUpperCase());
    }
    return langInner?.lang || defaultLang;
  } else {
    // 外部浏览器 h5
    const ual = navigator.language;
    const browserLang = ual ? ual.substring(0,2).toLowerCase() : "en";
    const langInner =langMap.find((item) => item.code == browserLang);
    console.log('browserLang:', langInner);
    return langInner?.lang || defaultLang;
  }
}

export const lang = getCurrentLanguage();

let currentData = LangData as any;
if (location.href.indexOf('/club-test/') !== -1 || location.href.indexOf('/club/') !== -1) {
  // 内嵌社区
  if (location.pathname.indexOf('/club-test/activity') !== -1 || location.pathname.indexOf('/club/activity') !== -1) {
    currentData = ActivityLangData;
  } else if (location.pathname.indexOf('/club-test/feed/review') !== -1 || location.pathname.indexOf('/club/feed/review') !== -1) {
    currentData = ReviewLangData;
  } else if (location.pathname.indexOf('/club-test/feedback') !== -1 || location.pathname.indexOf('/club/feedback') !== -1) {
    currentData = FeedbackLangData;
    // 集成一个通用的key
    currentData.club_auth_timmsg_error = InnerLangData.club_auth_timmsg_error;
  } else if (location.pathname.indexOf('/club-test/achievement') !== -1 || location.pathname.indexOf('/club/achievement') !== -1) {
    currentData = AchievementLangData;
  } else if (location.pathname.indexOf('/club-test/guide') !== -1 
    || location.pathname.indexOf('/club/guide') !== -1
    || location.pathname.indexOf('/club-test/topic') !== -1
    || location.pathname.indexOf('/club/topic') !== -1
    ) {
    console.log("**** GuideLangData: ", GuideLangData)
    currentData = GuideLangData;
  } else {
    currentData = InnerLangData;
  }
}

export const langData = currentData;

export function getTranslateValue (key: string, replace?: any) {
  try {
    if (langData[key] && langData[key][lang]) {
      if (replace) {
        if (Array.isArray(replace)) {
          return replace.reduce((pre: any, current: any, index: number, array: any) => {
            let source=''
            if(index == 0) {
              source = langData[key][lang]
            } else {
              source = pre;
            }
            return source.replace('%s', current)
          }, replace)
        }
        return langData[key][lang].replace('%s', replace)
      } else {
        return langData[key][lang]
      }
    } else {
      return key
    }
  } catch (e) {
    console.error(e)
    return key
  }
}

export function loadScript(url: string, ignoreError = true) {
  return new Promise((resolve, reject) => {
    let head = document.getElementsByTagName('head')[0]
    let js: any = document.createElement('script')
    js.setAttribute('type', 'text/javascript')
    js.setAttribute('src', url)
    js.setAttribute('charset', 'utf-8')
    head.appendChild(js)
    if (document.all) {
      js.onreadystatechange = function (res: any) {
        if (js.readyState === 'load' || js.readyState === 'complete') {
          resolve(res)
        }
      }
    } else {
      js.onload = resolve
    }
    js.onerror = ignoreError ? resolve : reject
  })
}

export function urltoFile(url: string, filename: string, mimeType: string){
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(function(res){return res.arrayBuffer();})
      .then(function(buf){ 
        resolve(new File([buf], filename,{type:mimeType}));
      }).catch((e: any) => {
        reject(null);
      });
  });
}
